module.exports = new __parcel__URL__("issue-app-skeleton.tpl.e425fdce.svg").toString();